import BaseController from "controllers/base"

class Controller extends BaseController {
  call() {
    super.call()
    bindAddInspection.call(this)
  }
}

let bindAddInspection = function() {
  $('body').on('change', '.inspection-type-select', (e) => {
    var inspection_type = $(e.target).val()
    var nameField = $(e.target).closest(".nested-fields").children().find("input")[2]
    var requirementField = $(e.target).closest(".nested-fields").children().find("textarea")

    $.ajax({
      url: "/searchables/inspection_type",
      type: "GET",
      data: {
        inspection_type: inspection_type
      },
      dataType: "json",
      success: (data) => {
        $(nameField).val(data.name)
        $(requirementField).html(data.requirement)
      }
    })
  })
}

export default Controller